export const taxiClasses = [
    { Id: 0, Name: "Экспресс" },
    { Id: 1, Name: "Курьер" }
];


// WEBPACK FOOTER //
// ./src/constants/taxiClasses.js